var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_4298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9957 13.3287C11.9957 12.2682 11.5744 11.2511 10.8245 10.5012C10.0747 9.75136 9.0576 9.33008 7.99711 9.33008C6.93663 9.33008 5.91957 9.75136 5.16969 10.5012C4.41981 11.2511 3.99854 12.2682 3.99854 13.3287",
    stroke: "#64748B",
    strokeWidth: 1.33286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99726 9.32997C9.4695 9.32997 10.663 8.13649 10.663 6.66425C10.663 5.19202 9.4695 3.99854 7.99726 3.99854C6.52503 3.99854 5.33154 5.19202 5.33154 6.66425C5.33154 8.13649 6.52503 9.32997 7.99726 9.32997Z",
    stroke: "#64748B",
    strokeWidth: 1.33286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99731 14.6614C11.6779 14.6614 14.6616 11.6777 14.6616 7.99706C14.6616 4.31647 11.6779 1.33276 7.99731 1.33276C4.31672 1.33276 1.33301 4.31647 1.33301 7.99706C1.33301 11.6777 4.31672 14.6614 7.99731 14.6614Z",
    stroke: "#64748B",
    strokeWidth: 1.33286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_4298"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9943,
    height: 15.9943,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.4ae8727daf1ff00500bbad386429ba4f.svg";
export { ForwardRef as ReactComponent };